import { offset, shift, useFloating } from "@floating-ui/react-dom";
import React from "react";
import ReactDOM from "react-dom";

import { SHELL_NOTIFICATION_ID } from "../views/main/Shell.types";
import NotificationAlert, { IProps as INotificationAlertProps } from "./NotificationAlert";
import { getZoomLevel } from "@utils/zoom.utils";

interface IProps extends Pick<INotificationAlertProps, "avatarSrc" | "title" | "subtitle" | "onFadeEnd"> {

}

const PopperNotificationAlert = React.memo((props: React.PropsWithChildren<IProps>) => {
    const notificationButton = document.getElementById(SHELL_NOTIFICATION_ID);

    const zoom = getZoomLevel();
    const zoomCorrectionMiddleware = {
        name: 'zoomCorrection',
        fn({ x, y }: { x: number; y: number }) {
            return {
                x: x / zoom,
                y: y / zoom,
            };
        },
    };

    const { floatingStyles, refs } = useFloating({
        placement: "right",
        middleware: [
            offset({ mainAxis: 20 }),
            shift({ padding: 19, rootBoundary: "viewport" }),
            zoomCorrectionMiddleware
        ]
    });

    refs.setReference(notificationButton);

    return ReactDOM.createPortal((
        <NotificationAlert
            avatarSrc={props.avatarSrc}
            title={props.title}
            subtitle={props.subtitle}
            onFadeEnd={props.onFadeEnd}

            passRef={refs.setFloating}
            style={floatingStyles}
        />
    ), document.getElementById("context-menu-root"));
});

export default PopperNotificationAlert;